// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__9q3su","left":"styles_left__odzAP"};